import SectionHeader from "./SectionHeader";

export default SectionHeader;
